import gql from 'graphql-tag';

export const LIST_COURSE_OUTSTANDING_EXEMPTIONS = gql`
  query ListCourseOutstandingExemptions($filter: CourseOutstandingExemptionFilterInput) {
    listCourseOutstandingExemptions(filter: $filter) {
      id
      school_id
      student_id
      course_id
      deleted
      createdAt
      updatedAt
      student {
        id
        first_name
        surname
        matric_no
      }
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
`;

export const GET_COURSE_OUTSTANDING_EXEMPTION = gql`
  query GetCourseOutstandingExemption($id: ID!) {
    getCourseOutstandingExemption(id: $id) {
      id
      school_id
      student_id
      course_id
      deleted
      createdAt
      updatedAt
      student {
        id
        first_name
        surname
        matric_no
      }
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
`;
